"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var icon_1 = require("../../../constants/img/icon");
var IconTextBtn_1 = require("./IconTextBtn");
var BackBtn = function (_a) {
    var onClick = _a.onClick;
    return (0, preact_1.h)(IconTextBtn_1.default, { onClick: onClick, img: icon_1.LEFT_ARROW, alt: '<', text: 'back' });
};
exports.default = BackBtn;
